import React, { lazy, Suspense, useLayoutEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import { Route, Routes, useLocation } from "react-router-dom";
import Loader from "./Loader";
import toast, { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreaters } from "../Redux";

import $ from "jquery";
import axios from "axios";

const UploadPointSheet = lazy(
  () => import("./UploadPointSheet/UploadPointSheet"),
);

const Login = lazy(() => import("./Login/Login"));
const VerifyUser = lazy(() => import("./Login/VerifyUser"));

const Sidebar = lazy(() => import("./Includes/SideCanvas/Sidebar"));
const ViewRequests = lazy(() => import("./UploadPointSheet/ViewRequests"));
const UpdateFile = lazy(() => import("./UploadPointSheet/UpdateFile"));

const NotFound = lazy(() => import("./NotFound"));

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>
            4<span>2</span>4
          </h1>
        </div>
        <h2>{error.message}</h2>
        <button
          className="btn btn-block btn-primary nm-btn"
          onClick={resetErrorBoundary}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
export default function Roots() {
  const locat = useLocation();
  const { user } = useSelector((state) => state.stateVals);
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 500) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  const backToTop = () => {
    return (
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0,
      ),
      !1
    );
  };

  const MoveToHome = () => {
    useLayoutEffect(() => {
      window.location.href = "/";

      // eslint-disable-next-line
    }, []);
    return <></>;
  };
  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    window.innerWidth > 1199 ? false : true,
  );
  useLayoutEffect(() => {
    backToTop();
    if (window.innerWidth < 1200) {
      setIsSidebarOpen(true);
    }

    if (locat?.pathname?.match(/\/{2,}/)) {
      window.location.href = "/";
    }

    const interceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error?.response?.status === 401 && locat.pathname !== "/") {
          setTimeout(async () => {
            await userActions.logOut("userLogOut");
            window.location.href = "/";
          }, 1000);

          toast.error("Unauthorized!", {
            position: "top-center",
            duration: 1000,

            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }

        return Promise.reject(error);
      },
    );

    const handleOutsideClick = (event) => {
      // Check if the click is outside the menu

      if (
        !$(event.target).closest(".menu-profile").length &&
        $(".menu-bottom").hasClass("open")
      ) {
        $(".menu-bottom").removeClass("open");
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    $(document).on("mousedown", handleOutsideClick);
    return () => {
      $(document).off("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", toggleVisibility);
      axios.interceptors.response.eject(interceptor);
    };
  }, [locat.pathname]);

  useLayoutEffect(() => {
    if (!user?.token_expires_at) return;

    if (
      !locat?.pathname?.startsWith("/verify-user/") &&
      locat.pathname !== "/"
    ) {
      const expiryTime = new Date(user?.token_expires_at).getTime();
      const currentTime = Date.now();
      const timeLeft = expiryTime - currentTime;

      if (timeLeft <= 0) {
        userActions.logOut("userLogOut");
        window.location.href = "/";
      } else {
        const timer = setTimeout(() => {
          userActions.logOut("userLogOut");
          window.location.href = "/";
        }, timeLeft);

        return () => clearTimeout(timer);
      }
    }
  }, []);
  return (
    <>
      <Toaster />
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          window.location.reload();
        }}
        onError={(error, info) => {
          // Log error or send it to a tracking service
          console.error("Caught an error:", error, info);
        }}
      >
        <Suspense fallback={<Loader />}>
          {locat.pathname !== "/" &&
          !locat?.pathname?.startsWith("/verify-user/") &&
          user ? (
            <Sidebar
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
          ) : null}

          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/verify-user/:type/:id"
              element={<VerifyUser />}
              caseSensitive={true}
            />

            <Route
              path="/dashboard"
              element={user ? <UploadPointSheet /> : <MoveToHome />}
            />
            <Route
              path="/list-requests"
              element={user ? <ViewRequests /> : <MoveToHome />}
            />
            <Route
              path="/edit-request/:id"
              element={user ? <UpdateFile /> : <MoveToHome />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>

      {locat.pathname.match(/\/{2,}/) ? (
        <div className="white-screen"></div>
      ) : null}
      {isVisible && (
        <button onClick={backToTop} className="to-top-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-arrow-up"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
            />
          </svg>
        </button>
      )}
    </>
  );
}
